import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { CommonTestAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';

interface CancelButtonProps {
    label?: string;
    disabled?: boolean;
    dataTest?: string;
    theme?: ButtonTheme;
    modifiers?: ButtonModifiers[];
    onCancelClick(): void;
}

export function CancelButton({
    label,
    disabled,
    dataTest = CommonTestAttributes.CancelButton,
    theme = ButtonTheme.White,
    modifiers,
    onCancelClick,
}: CancelButtonProps) {
    const tCancel = translate('cancel');

    return (
        <Button
            disabled={disabled}
            theme={theme}
            dataTest={dataTest}
            modifiers={modifiers}
            onClick={onCancelClick}
        >
            {label ? label : tCancel}
        </Button>
    );
}
